export class Footnote {
  text: string
  section: string
  id: number
  isAEM: boolean
  name: string

  constructor(text, section, isAEM, name) {
    this.text = text
    this.section = section
    this.id = 1
    this.isAEM = isAEM
    this.name = name
  }
}
